import { Component, EventEmitter, Input, Output } from '@angular/core';

import { List, ListProperty, User } from '@site-mate/dashpivot-shared-library';
import { CompanyPlanTypes } from '@site-mate/sitemate-global-shared/lib';

import { ListPropertyColumnMovedEvent } from 'app/lists/list-header-edit/list-property-column-moved.interface';
import { AppHierarchy } from 'app/shared/model/app-hierarchy.enum';

@Component({
  selector: 'cc-list-headers',
  templateUrl: './list-headers.component.html',
  styleUrls: ['./list-headers.component.scss'],
})
export class ListHeadersComponent {
  @Input() listId: string;
  @Input() itemCount: number;
  @Input() listProperties: ListProperty[];
  @Input() selectedItemCount: number;
  @Input() isDeployedList: boolean;
  @Input() users: User[];
  @Input() parentId: string;
  @Input() hierarchy: Exclude<AppHierarchy, AppHierarchy.Team>;
  @Input() planType?: CompanyPlanTypes;
  @Input() isUpgradeModalVisible: boolean;
  @Input() hasReachedPlanLimit: boolean;
  @Input() isInCreatePropertyMode: boolean;
  @Input() beforeAddPropertyIterator: Array<void>;
  @Input() afterAddPropertyIterator: Array<void>;
  @Input() addPropertyIndex: number;
  @Input() canEditProperties: boolean;

  @Output() propertyMoved = new EventEmitter<ListPropertyColumnMovedEvent>();
  @Output() propertyChanged = new EventEmitter<ListProperty>();
  @Output() propertyDeleted = new EventEmitter<ListProperty>();
  @Output() propertyAddedInBetween = new EventEmitter<List>();
  @Output() startAddProperty = new EventEmitter<number>();
  @Output() propertyAddCancelled = new EventEmitter<void>();
  @Output() propertyCreated = new EventEmitter<List>();
  @Output() toggleSelectAll = new EventEmitter<void>();

  onPropertyMove(event: ListPropertyColumnMovedEvent) {
    this.propertyMoved.emit(event);
  }

  onPropertyChange(event: ListProperty) {
    this.propertyChanged.emit(event);
  }

  onPropertyDelete(event: ListProperty) {
    this.propertyDeleted.emit(event);
  }

  onPropertyAddedInBetween(event: List) {
    this.propertyAddedInBetween.emit(event);
  }

  onStartAddProperty(index?: number) {
    this.startAddProperty.emit(index);
  }

  onCancelPropertyAdd() {
    this.propertyAddCancelled.emit();
  }

  onToggleSelectAll() {
    this.toggleSelectAll.emit();
  }

  onPropertyCreate(event: List) {
    this.propertyCreated.emit(event);
  }

  trackByBeforeAddPropertyColumn(index: number) {
    return this.listProperties[index];
  }

  trackByAfterAddPropertyColumn(index: number) {
    return this.listProperties ? this.listProperties[index + (this.addPropertyIndex || 0)] : null;
  }
}
